import { AvailableComponents } from "./Components";

export default function Info({ config }) {
  console.log('Info con', config)
  const wrapMode =
    window.screen.width < 920 ? false : config.config?.display === "FLEX_WRAP";

  return (
    <div
      className="info-section"
      style={{
        display: "flex",
        flexDirection: "row",
        flexWrap: "wrap",
        alignItems: "flex-start",
        justifyContent: "center",
        backgroundColor: config.background?.color || 'transparent',
        ...(config.style || {})
      }}
      id={config.config?.id}
    >
      {config.content.map((content, i) => {
        const Component = AvailableComponents[content.type];
        if (!Component) return null;
        return (
          <div
            className="info-box"
            style={{
              width: wrapMode
                ? `${100 / config.config.max_columns - 2}%`
                : "100%",
              minWidth: "300px",
              justifyContent: "center",
              display: "flex",
              flexDirection: "column",
            }}
          >
            <Component key={"component-" + i} config={content.settings} />
          </div>
        );
      })}
    </div>
  );
}
